/** Presence timing (M29 Phase 2, HND-003): mirror of the console-facing part of backend `app/core/constants/presence.py`.
 *  `backend/tests/core/test_presence_mirror.py` keeps every export equal to its backend twin. */

/** The console sends a heartbeat (the member's own status again) this often while they are active. */
export const PRESENCE_HEARTBEAT_S = 60 as const;

/** `online` with no heartbeat for this long reads as `away`; the stored choice stays `online`. */
export const PRESENCE_AUTO_AWAY_S = 300 as const;
